/**
 * BookMascot Component
 *
 * Animated book mascot for empty states, loading screens, and work-in-progress sections.
 * Features gentle floating animation and optional bounce.
 */

import { cn } from "@/lib/utils";

interface BookMascotProps {
  /** Size of the mascot */
  size?: "sm" | "md" | "lg" | "xl";
  /** Enable floating animation */
  animate?: boolean;
  /** Additional CSS classes */
  className?: string;
}

const sizeClasses = {
  sm: "w-16 h-16",
  md: "w-24 h-24",
  lg: "w-32 h-32",
  xl: "w-48 h-48",
};

export function BookMascot({
  size = "md",
  animate = true,
  className,
}: BookMascotProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-center",
        animate && "animate-float",
        className
      )}
    >
      <img
        src="/logo.svg"
        alt="MapQuizzr Book Mascot"
        className={cn(sizeClasses[size], "drop-shadow-lg")}
      />
    </div>
  );
}
